<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 400 265" enable-background="new 0 0 400 265" xml:space="preserve">
<path fill="#046862" opacity="1.000000" stroke="none" 
	d="
M371.000000,1.000000 
	C373.041656,1.000000 375.083344,1.000000 377.474854,1.381776 
	C378.083038,2.354568 378.205811,3.335602 378.619568,3.479409 
	C388.289886,6.840406 394.781677,13.396326 398.578217,22.828547 
	C398.826019,23.444218 400.167358,23.619741 401.000000,24.000004 
	C401.000000,96.687561 401.000000,169.375122 400.640564,242.457947 
	C399.670105,243.586807 398.832672,244.226440 398.483124,245.068558 
	C395.065002,253.303452 389.217072,259.166565 381.323578,263.169647 
	C380.061798,263.809540 379.100311,265.041656 378.000000,266.000000 
	C377.250000,266.000000 376.500000,266.000000 375.178314,265.653290 
	C372.747223,264.883392 370.888336,264.093384 369.028290,264.090668 
	C320.390717,264.019348 271.752960,264.029633 223.093979,263.622437 
	C223.678894,261.180176 224.438370,259.173035 224.867142,257.097565 
	C228.475510,239.631226 232.022934,222.152298 235.589615,204.677338 
	C236.940262,198.059830 238.355316,191.454758 239.630508,184.822754 
	C241.526474,174.962067 243.324310,165.082520 245.474182,155.024216 
	C246.496796,153.884842 247.527740,153.031570 247.861435,151.960953 
	C248.842606,148.813110 250.114288,145.601654 250.243134,142.374008 
	C250.522186,135.383148 254.411530,134.790421 260.286621,134.663834 
	C271.412659,134.424072 281.286865,130.751175 285.657959,119.283813 
	C290.331299,107.023430 287.305084,99.371452 273.308075,98.640228 
	C268.520691,98.390137 263.721954,98.357010 258.942322,97.799271 
	C260.829224,88.160423 262.653503,78.936829 264.586151,69.736000 
	C267.878815,54.060894 271.207703,38.393208 274.586884,22.736546 
	C276.012939,16.129274 277.605438,9.557923 279.583221,2.961544 
	C308.529663,2.952795 337.015320,2.988802 365.500305,2.868960 
	C367.336121,2.861236 369.166901,1.650901 371.000000,1.000000 
M312.757935,174.199692 
	C311.640137,176.316895 310.522339,178.434113 309.369598,180.617493 
	C319.309662,183.245468 325.034180,179.617355 328.929291,171.702972 
	C331.474854,166.530746 334.724304,161.705170 337.653839,156.721603 
	C344.330994,145.362793 351.005249,134.002319 357.739258,122.542877 
	C346.300018,119.996544 341.816620,127.111519 337.655792,135.472366 
	C337.173553,130.999557 336.691284,126.526733 336.166016,121.654800 
	C331.563110,122.342514 327.525726,122.945740 322.905304,123.636078 
	C323.662903,128.930588 324.106445,134.020157 325.160095,138.980118 
	C327.350433,149.290878 326.978485,158.975235 319.591919,167.343445 
	C317.583588,169.618729 315.542267,171.864914 312.757935,174.199692 
M278.171570,144.466309 
	C278.558716,151.750885 282.229675,155.516541 289.351746,155.549866 
	C295.410706,155.578217 301.486603,155.496628 307.518921,155.013321 
	C308.875977,154.904602 310.840668,153.138458 311.228455,151.768204 
	C312.935089,145.737976 314.215607,139.583969 315.551880,133.453323 
	C316.338593,129.844131 316.940613,126.194679 317.659637,122.383369 
	C310.425171,122.352913 303.969849,126.089180 297.476105,122.242462 
	C296.594482,121.720230 294.889923,122.407967 293.622345,122.745544 
	C285.135895,125.005638 279.497986,132.659454 278.171570,144.466309 
z"/>
<path fill="#DD2524" opacity="1.000000" stroke="none" 
	d="
M26.000000,266.000000 
	C25.555555,266.000000 25.111111,266.000000 24.567535,265.668701 
	C24.003080,264.899109 23.612345,264.295349 23.061394,264.047028 
	C12.306005,259.199707 3.838196,252.483017 2.690857,239.606201 
	C2.668554,239.355896 1.587231,239.199966 1.000000,239.000000 
	C1.000000,168.979111 1.000000,98.958206 1.358428,28.429596 
	C2.011320,27.819174 2.551732,27.741650 2.565191,27.610178 
	C3.557864,17.913801 9.001529,11.320367 17.030678,6.379421 
	C19.516058,4.849978 21.685764,2.807557 24.000000,1.000000 
	C24.444445,1.000000 24.888889,1.000000 25.874756,1.319238 
	C27.718180,2.056653 29.025030,2.851714 30.321436,2.835029 
	C44.116867,2.657487 57.910011,2.170759 71.705025,2.122107 
	C92.843117,2.047559 113.982170,2.250353 135.134537,2.729096 
	C132.559647,15.618745 130.018127,28.124712 127.372742,40.608669 
	C121.626297,67.726974 115.826805,94.834038 109.675125,122.078568 
	C104.380737,122.540169 101.038879,124.306030 101.879646,130.108139 
	C101.989174,130.863968 101.477959,131.701141 101.293213,132.509552 
	C99.645302,139.720520 98.006157,146.933517 96.299522,154.431046 
	C98.537956,154.688721 100.477013,154.911942 102.369873,155.555878 
	C97.612999,178.339005 92.903969,200.701782 88.191025,223.063721 
	C85.319870,236.686798 82.442696,250.308594 79.425667,264.068237 
	C79.170296,264.444183 79.050476,264.679291 78.460487,264.911682 
	C61.839569,264.643250 45.682182,264.333527 29.523312,264.188751 
	C28.354378,264.178284 27.174686,265.368195 26.000000,266.000000 
M97.008263,118.658768 
	C98.676491,112.201157 100.344727,105.743553 102.075577,99.043533 
	C97.000717,99.043533 92.729233,99.043533 88.133865,99.043533 
	C86.074554,108.605438 84.394348,118.090996 81.896034,127.355934 
	C80.469376,132.646652 78.568947,138.279816 75.209396,142.392670 
	C73.363846,144.652054 68.015892,144.633575 64.320610,144.412674 
	C63.324875,144.353149 61.693172,139.711884 61.923531,137.325317 
	C62.522953,131.115295 63.805504,124.947350 65.168198,118.841331 
	C66.628311,112.298798 68.491096,105.846130 70.327553,98.779289 
	C65.214523,98.779289 60.716152,98.427681 56.333702,98.986000 
	C54.955860,99.161537 53.718071,101.679398 52.748894,103.321541 
	C52.225048,104.209129 52.489292,105.529816 52.251690,106.623329 
	C49.857502,117.642014 47.339241,128.634705 45.053299,139.675583 
	C43.749527,145.972656 45.393761,150.642914 51.560841,152.370163 
	C58.042789,154.185623 65.215691,154.413940 72.007965,154.010605 
	C79.848351,153.545044 86.619675,149.568649 89.687988,142.079300 
	C92.675690,134.786728 94.332466,126.948875 97.008263,118.658768 
z"/>
<path fill="#36807A" opacity="1.000000" stroke="none" 
	d="
M223.115250,264.025909 
	C271.752960,264.029633 320.390717,264.019348 369.028290,264.090668 
	C370.888336,264.093384 372.747223,264.883392 374.803314,265.653290 
	C324.645782,266.000000 274.291534,266.000000 223.439194,265.701843 
	C222.917587,265.205383 222.894089,265.007019 222.927979,264.612396 
	C222.985336,264.416107 223.115250,264.025909 223.115250,264.025909 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M401.000000,23.531265 
	C400.167358,23.619741 398.826019,23.444218 398.578217,22.828547 
	C394.781677,13.396326 388.289886,6.840406 378.619568,3.479409 
	C378.205811,3.335602 378.083038,2.354568 377.912354,1.381776 
	C385.592957,1.000000 393.185913,1.000000 401.000000,1.000000 
	C401.000000,8.352704 401.000000,15.707616 401.000000,23.531265 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M23.531263,1.000000 
	C21.685764,2.807557 19.516058,4.849978 17.030678,6.379421 
	C9.001529,11.320367 3.557864,17.913801 2.565191,27.610178 
	C2.551732,27.741650 2.011320,27.819174 1.358428,27.960938 
	C1.000000,19.079538 1.000000,10.159078 1.000000,1.000000 
	C8.352462,1.000000 15.707495,1.000000 23.531263,1.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M1.000000,239.468658 
	C1.587231,239.199966 2.668554,239.355896 2.690857,239.606201 
	C3.838196,252.483017 12.306005,259.199707 23.061394,264.047028 
	C23.612345,264.295349 24.003080,264.899109 24.234203,265.668701 
	C16.401066,266.000000 8.802132,266.000000 1.000000,266.000000 
	C1.000000,257.313507 1.000000,248.625412 1.000000,239.468658 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M378.468750,266.000000 
	C379.100311,265.041656 380.061798,263.809540 381.323578,263.169647 
	C389.217072,259.166565 395.065002,253.303452 398.483124,245.068558 
	C398.832672,244.226440 399.670105,243.586807 400.640564,242.926605 
	C401.000000,250.592957 401.000000,258.185913 401.000000,266.000000 
	C393.647308,266.000000 386.292389,266.000000 378.468750,266.000000 
z"/>
<path fill="#36807A" opacity="1.000000" stroke="none" 
	d="
M370.531342,1.000000 
	C369.166901,1.650901 367.336121,2.861236 365.500305,2.868960 
	C337.015320,2.988802 308.529663,2.952795 279.510437,2.740653 
	C278.976685,2.528463 278.843414,2.083337 279.072632,1.944551 
	C279.534546,1.537180 279.767273,1.268595 280.000000,1.000004 
	C310.020905,1.000000 340.041779,1.000000 370.531342,1.000000 
z"/>
<path fill="#4F5E7E" opacity="1.000000" stroke="none" 
	d="
M222.870605,264.808716 
	C222.894089,265.007019 222.917587,265.205383 222.970535,265.701843 
	C175.312439,266.000000 127.624878,266.000000 79.483093,265.725342 
	C78.993790,265.270721 78.958717,265.090759 78.923653,264.910828 
	C79.050476,264.679291 79.170296,264.444183 79.854294,264.210266 
	C81.890640,264.444153 83.355789,264.873291 84.820961,264.873413 
	C130.837509,264.877563 176.854065,264.839966 222.870605,264.808716 
z"/>
<path fill="#4F5F7E" opacity="1.000000" stroke="none" 
	d="
M279.531342,1.000004 
	C279.767273,1.268595 279.534546,1.537180 278.620422,1.951215 
	C230.640686,2.082198 183.342331,2.067732 135.999847,1.791334 
	C135.970474,1.352934 135.985245,1.176467 136.000000,1.000000 
	C183.687561,1.000000 231.375122,1.000000 279.531342,1.000004 
z"/>
<path fill="#E35756" opacity="1.000000" stroke="none" 
	d="
M135.531342,1.000000 
	C135.985245,1.176467 135.970474,1.352934 135.763916,1.844828 
	C135.572113,2.160255 135.120819,2.335434 135.120819,2.335434 
	C113.982170,2.250353 92.843117,2.047559 71.705025,2.122107 
	C57.910011,2.170759 44.116867,2.657487 30.321436,2.835029 
	C29.025030,2.851714 27.718180,2.056653 26.208088,1.319238 
	C62.354229,1.000000 98.708458,1.000000 135.531342,1.000000 
z"/>
<path fill="#E35756" opacity="1.000000" stroke="none" 
	d="
M78.460487,264.911682 
	C78.958717,265.090759 78.993790,265.270721 79.014435,265.725342 
	C61.645771,266.000000 44.291542,266.000000 26.468657,266.000000 
	C27.174686,265.368195 28.354378,264.178284 29.523312,264.188751 
	C45.682182,264.333527 61.839569,264.643250 78.460487,264.911682 
z"/>
<path fill="#17325F" opacity="1.000000" stroke="none" 
	d="
M135.134537,2.729096 
	C135.120819,2.335434 135.572113,2.160255 135.808044,2.106761 
	C183.342331,2.067732 230.640686,2.082198 278.391235,2.090000 
	C278.843414,2.083337 278.976685,2.528463 279.049500,2.749355 
	C277.605438,9.557923 276.012939,16.129274 274.586884,22.736546 
	C271.207703,38.393208 267.878815,54.060894 264.586151,69.736000 
	C262.653503,78.936829 260.829224,88.160423 258.518005,97.959000 
	C255.760925,98.584724 253.398987,98.924820 251.132782,98.599007 
	C247.249084,98.040627 245.936142,100.020493 245.161270,103.352051 
	C242.359818,115.397095 239.387329,127.402237 236.518951,139.431870 
	C235.351273,144.329010 234.284882,149.250290 233.093323,154.509583 
	C237.649704,154.774353 241.406799,154.992676 245.163910,155.210999 
	C243.324310,165.082520 241.526474,174.962067 239.630508,184.822754 
	C238.355316,191.454758 236.940262,198.059830 235.589615,204.677338 
	C232.022934,222.152298 228.475510,239.631226 224.867142,257.097565 
	C224.438370,259.173035 223.678894,261.180176 223.093979,263.622437 
	C223.115250,264.025909 222.985336,264.416107 222.927979,264.612427 
	C176.854065,264.839966 130.837509,264.877563 84.820961,264.873413 
	C83.355789,264.873291 81.890640,264.444153 79.996857,264.072998 
	C82.442696,250.308594 85.319870,236.686798 88.191025,223.063721 
	C92.903969,200.701782 97.612999,178.339005 102.741898,155.427887 
	C108.281273,155.470261 110.594742,153.333801 111.019691,148.043518 
	C111.387695,143.462189 112.556023,138.868164 114.015404,134.494934 
	C114.499229,133.045105 116.987114,132.264038 118.558754,131.177216 
	C118.988815,132.715881 119.991676,134.351746 119.749924,135.776413 
	C118.695412,141.990372 117.279228,148.142944 115.925652,154.648071 
	C120.016304,154.648071 123.310745,154.780807 126.581673,154.562057 
	C127.487915,154.501434 128.924606,153.531509 129.100021,152.750244 
	C130.868057,144.875992 132.785278,137.004974 133.908310,129.027161 
	C134.614120,124.013161 131.816040,121.111557 126.872284,121.998314 
	C121.145630,123.025490 115.649734,122.421104 110.048996,121.945702 
	C115.826805,94.834038 121.626297,67.726974 127.372742,40.608669 
	C130.018127,28.124712 132.559647,15.618745 135.134537,2.729096 
M153.827698,129.149155 
	C153.182281,128.704681 152.536850,128.260208 151.673248,127.665489 
	C152.975693,126.423599 154.739853,125.500237 155.112839,124.182945 
	C155.526642,122.721542 154.699860,119.464493 154.362473,119.457550 
	C150.880569,119.385941 147.149170,119.151772 143.970123,120.299927 
	C141.113602,121.331589 139.248444,123.989258 142.546570,127.224060 
	C143.097580,127.764496 142.411255,129.566513 141.604324,130.679779 
	C140.744904,133.022797 139.684204,135.314117 139.066696,137.719238 
	C137.649033,143.240997 136.447342,148.818207 135.082642,154.697433 
	C138.932388,154.697433 142.418243,154.949814 145.832275,154.564987 
	C147.082108,154.424103 148.908279,152.955078 149.196671,151.779236 
	C150.964874,144.570023 152.367401,137.271118 153.827698,129.149155 
M157.735367,149.401337 
	C160.720779,155.743088 170.278702,156.267365 177.427597,154.435913 
	C187.247025,151.920334 190.785843,144.375900 192.223434,135.116760 
	C193.072327,129.649307 191.180954,125.094292 186.252045,122.946823 
	C179.256973,119.899162 168.104568,122.010742 163.241882,127.864044 
	C160.783157,130.823639 159.273987,134.572098 156.539001,138.175415 
	C154.051804,142.109253 154.309418,146.428085 157.735367,149.401337 
M206.211990,151.981720 
	C207.465500,146.494873 208.931824,141.045135 209.897446,135.508087 
	C210.537048,131.840515 212.368637,130.875183 216.817902,131.724442 
	C215.441254,139.353058 214.088898,146.847046 212.677002,154.670975 
	C216.195892,154.670975 219.369598,154.987854 222.423508,154.521057 
	C223.715363,154.323593 225.446350,152.660889 225.793152,151.350647 
	C227.529541,144.790222 228.887436,138.128998 230.351074,131.497192 
	C231.794769,124.955742 228.997604,121.469505 222.326340,121.880669 
	C219.408539,122.060501 215.692154,124.358292 213.800308,123.234116 
	C208.493088,120.080437 204.139923,123.760025 199.582764,123.278641 
	C198.352768,128.980652 197.292709,134.111420 196.130951,139.219025 
	C194.990875,144.231369 193.747391,149.220215 192.438705,154.680771 
	C196.151398,154.680771 198.956863,154.890518 201.708649,154.597015 
	C203.205093,154.437424 204.610336,153.422668 206.211990,151.981720 
z"/>
<path fill="#F6F8F8" opacity="1.000000" stroke="none" 
	d="
M245.474182,155.024200 
	C241.406799,154.992676 237.649704,154.774353 233.093323,154.509583 
	C234.284882,149.250290 235.351273,144.329010 236.518951,139.431870 
	C239.387329,127.402237 242.359818,115.397095 245.161270,103.352051 
	C245.936142,100.020493 247.249084,98.040627 251.132782,98.599007 
	C253.398987,98.924820 255.760925,98.584724 258.504089,98.384491 
	C263.721954,98.357010 268.520691,98.390137 273.308075,98.640228 
	C287.305084,99.371452 290.331299,107.023430 285.657959,119.283813 
	C281.286865,130.751175 271.412659,134.424072 260.286621,134.663834 
	C254.411530,134.790421 250.522186,135.383148 250.243134,142.374008 
	C250.114288,145.601654 248.842606,148.813110 247.861435,151.960953 
	C247.527740,153.031570 246.496796,153.884842 245.474182,155.024200 
M254.995499,121.778557 
	C254.005737,124.836441 255.177521,126.419640 258.298767,125.848595 
	C261.174133,125.322548 264.117584,124.592033 266.728668,123.327347 
	C271.111603,121.204445 272.633789,116.968719 272.022522,112.554306 
	C271.321320,107.490425 266.970856,107.126022 262.813171,107.124077 
	C261.355499,107.123398 259.897827,107.123970 258.526459,107.123970 
	C257.925751,109.730400 257.443024,111.972984 256.886719,114.197159 
	C256.324493,116.445129 255.689407,118.674866 254.995499,121.778557 
z"/>
<path fill="#F4F8F8" opacity="1.000000" stroke="none" 
	d="
M313.137024,174.162079 
	C315.542267,171.864914 317.583588,169.618729 319.591919,167.343445 
	C326.978485,158.975235 327.350433,149.290878 325.160095,138.980118 
	C324.106445,134.020157 323.662903,128.930588 322.905304,123.636078 
	C327.525726,122.945740 331.563110,122.342514 336.166016,121.654800 
	C336.691284,126.526733 337.173553,130.999557 337.655792,135.472366 
	C341.816620,127.111519 346.300018,119.996544 357.739258,122.542877 
	C351.005249,134.002319 344.330994,145.362793 337.653839,156.721603 
	C334.724304,161.705170 331.474854,166.530746 328.929291,171.702972 
	C325.034180,179.617355 319.309662,183.245468 309.369598,180.617493 
	C310.522339,178.434113 311.640137,176.316895 313.137024,174.162079 
z"/>
<path fill="#F4F7F7" opacity="1.000000" stroke="none" 
	d="
M278.173218,144.043396 
	C279.497986,132.659454 285.135895,125.005638 293.622345,122.745544 
	C294.889923,122.407967 296.594482,121.720230 297.476105,122.242462 
	C303.969849,126.089180 310.425171,122.352913 317.659637,122.383369 
	C316.940613,126.194679 316.338593,129.844131 315.551880,133.453323 
	C314.215607,139.583969 312.935089,145.737976 311.228455,151.768204 
	C310.840668,153.138458 308.875977,154.904602 307.518921,155.013321 
	C301.486603,155.496628 295.410706,155.578217 289.351746,155.549866 
	C282.229675,155.516541 278.558716,151.750885 278.173218,144.043396 
M293.498016,148.070175 
	C298.838684,147.298492 301.770264,142.789871 301.509277,134.934464 
	C301.456329,133.340881 299.859955,131.798584 298.975098,130.232651 
	C297.293396,131.244095 294.942139,131.867447 294.080353,133.354156 
	C292.637909,135.842606 291.743835,138.832794 291.392334,141.706406 
	C291.150208,143.685715 292.213867,145.824753 293.498016,148.070175 
z"/>
<path fill="#FDF6F5" opacity="1.000000" stroke="none" 
	d="
M96.790932,119.004601 
	C94.332466,126.948875 92.675690,134.786728 89.687988,142.079300 
	C86.619675,149.568649 79.848351,153.545044 72.007965,154.010605 
	C65.215691,154.413940 58.042789,154.185623 51.560841,152.370163 
	C45.393761,150.642914 43.749527,145.972656 45.053299,139.675583 
	C47.339241,128.634705 49.857502,117.642014 52.251690,106.623329 
	C52.489292,105.529816 52.225048,104.209129 52.748894,103.321541 
	C53.718071,101.679398 54.955860,99.161537 56.333702,98.986000 
	C60.716152,98.427681 65.214523,98.779289 70.327553,98.779289 
	C68.491096,105.846130 66.628311,112.298798 65.168198,118.841331 
	C63.805504,124.947350 62.522953,131.115295 61.923531,137.325317 
	C61.693172,139.711884 63.324875,144.353149 64.320610,144.412674 
	C68.015892,144.633575 73.363846,144.652054 75.209396,142.392670 
	C78.568947,138.279816 80.469376,132.646652 81.896034,127.355934 
	C84.394348,118.090996 86.074554,108.605438 88.133865,99.043533 
	C92.729233,99.043533 97.000717,99.043533 102.075577,99.043533 
	C100.344727,105.743553 98.676491,112.201157 96.790932,119.004601 
z"/>
<path fill="#F6F4F5" opacity="1.000000" stroke="none" 
	d="
M109.675125,122.078568 
	C115.649734,122.421104 121.145630,123.025490 126.872284,121.998314 
	C131.816040,121.111557 134.614120,124.013161 133.908310,129.027161 
	C132.785278,137.004974 130.868057,144.875992 129.100021,152.750244 
	C128.924606,153.531509 127.487915,154.501434 126.581673,154.562057 
	C123.310745,154.780807 120.016304,154.648071 115.925652,154.648071 
	C117.279228,148.142944 118.695412,141.990372 119.749924,135.776413 
	C119.991676,134.351746 118.988815,132.715881 118.558754,131.177216 
	C116.987114,132.264038 114.499229,133.045105 114.015404,134.494934 
	C112.556023,138.868164 111.387695,143.462189 111.019691,148.043518 
	C110.594742,153.333801 108.281273,155.470261 102.788086,155.007172 
	C100.477013,154.911942 98.537956,154.688721 96.299522,154.431046 
	C98.006157,146.933517 99.645302,139.720520 101.293213,132.509552 
	C101.477959,131.701141 101.989174,130.863968 101.879646,130.108139 
	C101.038879,124.306030 104.380737,122.540169 109.675125,122.078568 
z"/>
<path fill="#F3F4F6" opacity="1.000000" stroke="none" 
	d="
M206.134354,152.387665 
	C204.610336,153.422668 203.205093,154.437424 201.708649,154.597015 
	C198.956863,154.890518 196.151398,154.680771 192.438705,154.680771 
	C193.747391,149.220215 194.990875,144.231369 196.130951,139.219025 
	C197.292709,134.111420 198.352768,128.980652 199.582764,123.278641 
	C204.139923,123.760025 208.493088,120.080437 213.800308,123.234116 
	C215.692154,124.358292 219.408539,122.060501 222.326340,121.880669 
	C228.997604,121.469505 231.794769,124.955742 230.351074,131.497192 
	C228.887436,138.128998 227.529541,144.790222 225.793152,151.350647 
	C225.446350,152.660889 223.715363,154.323593 222.423508,154.521057 
	C219.369598,154.987854 216.195892,154.670975 212.677002,154.670975 
	C214.088898,146.847046 215.441254,139.353058 216.817902,131.724442 
	C212.368637,130.875183 210.537048,131.840515 209.897446,135.508087 
	C208.931824,141.045135 207.465500,146.494873 206.134354,152.387665 
z"/>
<path fill="#F6F7F8" opacity="1.000000" stroke="none" 
	d="
M157.335495,137.963882 
	C159.273987,134.572098 160.783157,130.823639 163.241882,127.864044 
	C168.104568,122.010742 179.256973,119.899162 186.252045,122.946823 
	C191.180954,125.094292 193.072327,129.649307 192.223434,135.116760 
	C190.785843,144.375900 187.247025,151.920334 177.427597,154.435913 
	C170.278702,156.267365 160.720779,155.743088 157.445587,148.750275 
	C157.215683,144.720764 157.275589,141.342331 157.335495,137.963882 
M169.994995,142.048706 
	C170.261581,142.631851 170.600327,143.193726 170.779846,143.802551 
	C171.163727,145.104507 171.465225,146.430756 171.800476,147.747055 
	C173.273788,146.921616 175.565887,146.432816 176.069260,145.208572 
	C177.679062,141.293457 178.818375,137.146408 179.695724,132.995132 
	C179.921265,131.927948 178.649078,129.593323 177.827271,129.473679 
	C176.523209,129.283875 174.261734,130.092438 173.741089,131.141541 
	C172.153275,134.341019 171.203583,137.857162 169.994995,142.048706 
z"/>
<path fill="#EFF0F3" opacity="1.000000" stroke="none" 
	d="
M153.891693,130.002075 
	C152.367401,137.271118 150.964874,144.570023 149.196671,151.779236 
	C148.908279,152.955078 147.082108,154.424103 145.832275,154.564987 
	C142.418243,154.949814 138.932388,154.697433 135.082642,154.697433 
	C136.447342,148.818207 137.649033,143.240997 139.066696,137.719238 
	C139.684204,135.314117 140.744904,133.022797 142.411850,130.788574 
	C146.776810,130.598938 150.334259,130.300507 153.891693,130.002075 
z"/>
<path fill="#EBEDF1" opacity="1.000000" stroke="none" 
	d="
M153.859695,129.575623 
	C150.334259,130.300507 146.776810,130.598938 142.758026,130.841476 
	C142.411255,129.566513 143.097580,127.764496 142.546570,127.224060 
	C139.248444,123.989258 141.113602,121.331589 143.970123,120.299927 
	C147.149170,119.151772 150.880569,119.385941 154.362473,119.457550 
	C154.699860,119.464493 155.526642,122.721542 155.112839,124.182945 
	C154.739853,125.500237 152.975693,126.423599 151.673248,127.665489 
	C152.536850,128.260208 153.182281,128.704681 153.859695,129.575623 
z"/>
<path fill="#092457" opacity="1.000000" stroke="none" 
	d="
M156.937256,138.069641 
	C157.275589,141.342331 157.215683,144.720764 157.170837,148.559601 
	C154.309418,146.428085 154.051804,142.109253 156.937256,138.069641 
z"/>
<path fill="#106E68" opacity="1.000000" stroke="none" 
	d="
M255.040863,121.345573 
	C255.689407,118.674866 256.324493,116.445129 256.886719,114.197159 
	C257.443024,111.972984 257.925751,109.730400 258.526459,107.123970 
	C259.897827,107.123970 261.355499,107.123398 262.813171,107.124077 
	C266.970856,107.126022 271.321320,107.490425 272.022522,112.554306 
	C272.633789,116.968719 271.111603,121.204445 266.728668,123.327347 
	C264.117584,124.592033 261.174133,125.322548 258.298767,125.848595 
	C255.177521,126.419640 254.005737,124.836441 255.040863,121.345573 
z"/>
<path fill="#17716B" opacity="1.000000" stroke="none" 
	d="
M293.095978,147.981293 
	C292.213867,145.824753 291.150208,143.685715 291.392334,141.706406 
	C291.743835,138.832794 292.637909,135.842606 294.080353,133.354156 
	C294.942139,131.867447 297.293396,131.244095 298.975098,130.232651 
	C299.859955,131.798584 301.456329,133.340881 301.509277,134.934464 
	C301.770264,142.789871 298.838684,147.298492 293.095978,147.981293 
z"/>
<path fill="#29426C" opacity="1.000000" stroke="none" 
	d="
M170.000275,141.649384 
	C171.203583,137.857162 172.153275,134.341019 173.741089,131.141541 
	C174.261734,130.092438 176.523209,129.283875 177.827271,129.473679 
	C178.649078,129.593323 179.921265,131.927948 179.695724,132.995132 
	C178.818375,137.146408 177.679062,141.293457 176.069260,145.208572 
	C175.565887,146.432816 173.273788,146.921616 171.800476,147.747055 
	C171.465225,146.430756 171.163727,145.104507 170.779846,143.802551 
	C170.600327,143.193726 170.261581,142.631851 170.000275,141.649384 
z"/>
</svg>